// https://sistemas.ucasal.edu.ar/sagbackend/api/v1/registro-inicial/lovs/sectores2?tipo-estudio=Grado&carrera=${id_carrera}&lugar=${id_lugar}&modo=${id_modo}

import { SERVICES_URL } from "../../config/config";
import { connection } from "../../utils/connection";


const getListSectors = async ({ token, callbacks, params }) => {
    //const response = await connection({ method: 'GET', url: `${SERVICES_URL.SECTOR.LIST}`, token, params });
    //?modo=7&lugar=60&tipo-estudio=Pregrado&carrera=11
    /*
    const res= await fetch(SERVICES_URL.SECTOR.LIST+'?modo='+params.modo+'&lugar='+params.lugar+'&tipo-estudio='+params.tipoEstudio+'&carrera='+params.carrera)
    const data = await res.json();
    if (typeof callbacks === "function") {
        callbacks(data);
    }
    */
    // const res= await fetch(`${'http://localhost:8080/v1/ingresos/lovs/sectores'}?tipo-estudio=${params.tipoEstudio}&carrera=${params.carrera}&lugar=${params.lugar}&modo=${params.modo}`,{
    const res= await fetch(`${SERVICES_URL.SECTOR.LIST}?tipo-estudio=${params.tipoEstudio}&carrera=${params.carrera}&lugar=${params.lugar}&modo=${params.modo}`,{
        headers: {
            'auth': token,
        }
    })
    
    if (typeof callbacks === "function") {
        //callbacks(data);
        if (res.status == 200){
            callbacks({
                success: true,
                data: await res.json()
            })
        }else{
            callbacks({
                success: false,
                error: await res.json()
            });
        }
    }
}

export default getListSectors;

